import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  	selector: '[appInputRestriction]'
})
export class InputRestrictionDirective {

	inputElement: ElementRef;

	@Input() inputRestrictions: string[];
  	constructor(
		el: ElementRef,
	) { 
		this.inputElement = el;
	}

	@HostListener('keypress', ['$event']) onKeyPress(event) {
		const e = <KeyboardEvent>event;

		// if (this.inputRestrictions.includes('noSpaces')) {
		// 	let j = event.charCode;
		// 	if (j === 32) {
		// 		e.preventDefault();
		// 	}
		// }

		if (this.inputRestrictions.includes('noSpecialChars')) {
			let k = event.charCode; 
			if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57)) {
				return;
			}
		}
			
		e.preventDefault();
	}
}
